
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#FFF","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 1000 1000","enable-background":"new 0 0 1000 1000","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('g',{attrs:{"transform":"translate(0.000000,512.000000) scale(0.100000,-0.100000)"}},[_c('path',{attrs:{"d":"M1037.3,5011.7C628.6,4956,269.8,4649,143.1,4244.1c-51.8-165-55.6-443.3-9.6-602.5c86.4-289.8,25-222.6,1734.7-1934.3l1587-1588.9l-1587-1587C158.5-3182.3,219.9-3115.1,133.5-3404.9c-48-159.3-44.1-439.4,9.6-602.6c109.4-347.3,385.7-621.7,731.1-731.1c163.1-53.7,443.3-57.6,602.6-9.6c289.8,86.3,222.6,24.9,1936.2,1734.7l1587,1587l1588.9-1587c1711.7-1709.8,1644.5-1648.4,1934.3-1734.7c159.3-48,439.5-44.2,602.6,9.6c347.3,109.4,621.8,385.7,731.1,731.1c53.7,163.1,57.6,443.3,9.6,602.6c-86.3,289.8-24.9,222.6-1734.7,1936.2l-1587,1587l1587,1588.9c1709.8,1711.7,1648.4,1644.6,1734.7,1934.3c48,159.3,44.2,439.4-9.6,602.5c-109.4,345.4-383.8,621.7-731.1,731.1c-163.1,53.7-443.3,57.6-602.6,9.6c-289.8-86.3-222.6-25-1934.3-1734.7L5000,1663.1l-1587,1587c-1381.7,1379.7-1604.2,1592.7-1706,1642.6C1490.2,5002.1,1259.9,5042.4,1037.3,5011.7z"}})])])])
          )
        }
      }
    